import React from 'react';
import moment from 'moment';
import { prescriptionDurationChartConfig } from 'utils/chartConfig';
import CircleChart from 'components/common/CircleChart';
import { DATE_FORMATS } from 'utils/dateTime';
import { IProps } from './types';
import styles from './styles.module.scss';

/**
 * Displays summary information about the patient.
 * @param props The props
 * @return A JSX Element
 */
function PatientInfo(props: IProps): JSX.Element {
  const {
    firstName,
    lastName,
    dateOfBirth,
    pearConnectRef,
    duration,
    startDate,
    remainingDays,
    isExpired,
    isSample,
    program,
    timezone,
  } = props;
  let formattedStartedDate = '';
  let formattedDOB = '';
  if (startDate) {
    if (timezone) {
      formattedStartedDate = moment(startDate)
        .tz(timezone)
        .format(DATE_FORMATS.M_D_YYYY);
    } else {
      formattedStartedDate = moment(startDate).format(DATE_FORMATS.M_D_YYYY);
    }
  }
  if (dateOfBirth) {
    formattedDOB = moment(dateOfBirth).format(DATE_FORMATS.M_D_YYYY);
  }
  return (
    <div data-testid="patient-info">
      <div className={styles.wrapper} data-testid="presented-state-id">
        <CircleChart
          id="patient-info-chart"
          status={{
            isExpired,
            remainingDaysChart: remainingDays,
            remainingPercentage: (100 * remainingDays) / duration,
            unit: `${remainingDays === 1 ? 'DAY' : 'DAYS'}<br />LEFT`,
          }}
          customStyle={styles.chart}
          chartConfig={prescriptionDurationChartConfig}
        />
        <div className={styles.info}>
          <div
            className={styles['full-name']}
            title={`${firstName} ${lastName}`}
          >
            <div aria-label="First name">{firstName}&nbsp;</div>
            <div aria-label="Last Name">{lastName}</div>
          </div>
          <div className={styles.detail}>
            <span>{`DOB: ${formattedDOB}`}</span>
            <span>
              {isSample
                ? 'Sample Prescription'
                : `${duration}-day Prescription`}
            </span>
            <span>{`Started: ${formattedStartedDate}`}</span>
            <span>
              Product: <strong>{program}</strong>
            </span>
            <span>External ID: {pearConnectRef}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PatientInfo;
